import { ArrowBack } from "@mui/icons-material";
import { Card, CardContent, CardHeader, IconButton } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import TabelPerencanaan from "examples/Tables/TabelPerencanaan";
import { CustomDescrypt } from "global/func";
import { getDataWithResponse } from "global/getFunc";
import { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import { useLocation, useNavigate } from "react-router-dom";
import userStore from "store/userStore";

const Detail = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const navigate = useNavigate()
    const location = useLocation()
    const locationData = location.state
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const reqPerencanaan = (params) => {
        if (params) {
            setLoading(true)
            addReq()
            getDataWithResponse(
                // `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
                `/admin-opd/get-tr-perencanaan-opd/${tahunAnggaran.ta}/${params}`,
                decryptedUser,
                (res) => {
                    setData(res)
                    setLoading(false)
                },
                (res) => {
                    console.log(res)
                    setLoading(false)
                }
            );
        }
    }

    useEffect(() => {
        console.log(locationData);
        reqPerencanaan(locationData.kd_pd)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Kembali</ArgonTypography>
                        }
                        avatar={
                            <IconButton variant="outlined" onClick={() => navigate(-1)}><ArrowBack /></IconButton>
                        }
                    />
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Perencanaan OPD</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                            spacing={2}
                        >

                            <TabelPerencanaan
                                data={data}
                                loading={loading}
                                // handleOpenAddChild={handleOpenAddChild}
                                // setParentData={setParentData}
                                // setEditData={setEditData}
                                // handleOpenEdit={handleOpenEdit}
                                // deleteData={deleteData}
                                opd={locationData}
                                baseUrl="/a-pemb/perencanaan"
                                allowEdit={false}
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Detail